/* eslint-disable import/order */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState, useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { StepIconProps } from '@mui/material/StepIcon';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

import { ImEarth } from 'react-icons/im';
import { SiTelegram, SiDiscord, SiTwitter, SiYoutube, SiLinkedin, SiMedium } from 'react-icons/si';

import { useGetAccountInfo, useGetNetworkConfig, useGetIsLoggedIn, useGetPendingTransactions } from '@multiversx/sdk-dapp/hooks';
import { ProxyNetworkProvider } from '@multiversx/sdk-network-providers/out';
import { sendTransactions } from '@multiversx/sdk-dapp/services';
import { refreshAccount } from '@multiversx/sdk-dapp/utils';
import { useTrackTransactionStatus } from '@multiversx/sdk-dapp/hooks';
import { Account, Address, AddressValue, ContractFunction, Interaction, ResultsParser, SmartContract, SmartContractAbi, TokenPayment, TypedValue, U32Value, U64Value, BytesValue, BigUIntValue, ArgSerializer, TransactionPayload } from '@multiversx/sdk-core';
import axios from 'axios';
import BigNumber from 'bignumber.js/bignumber.js';
import { contracts, ElrondApiUrl, isDev, WEGLD_ID, USDC_ID, LAUNCHPAD_CONFIG } from 'config/config';
import { convertWeiToEsdt, convertEsdtToWei } from 'helpers/utils';

import { routeNames } from 'routes';
import { toast } from 'react-toastify';
import moment from 'moment';

import congratulations_img from 'assets/img/congratulations.png';
import './index.scss';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 8,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            // backgroundImage:
            //     'linear-gradient( 95deg, rgb(53 220 158) 0%, rgb(23 149 85) 50%, rgb(2 86 68) 100%)',

            background: '#FFBC0A'
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            // backgroundImage:
            //     'linear-gradient( 95deg, rgb(53 220 158) 0%, rgb(23 149 85) 50%, rgb(2 86 68) 100%)',
            background: '#FFBC0A'
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 2,
        border: 0,
        backgroundColor:
            theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#D3D3D3',
        borderRadius: 1,
    },
}));

const ColorlibStepIconRoot = styled('div')<{
    ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#fff',
    // border: '1px solid gray',
    zIndex: 1,
    color: '#000',
    width: 20,
    height: 20,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '12px',
    ...(ownerState.active && {

        // backgroundImage:
        //     'linear-gradient( 136deg, rgb(53 220 158) 0%, rgb(23 149 85) 50%, rgb(2 86 68) 100%)',
        background: '#FFBC0A',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
        color: '#000',
    }),
    ...(ownerState.completed && {
        // backgroundImage:
        //     'linear-gradient( 136deg, rgb(53 220 158) 0%, rgb(23 149 85) 50%, rgb(2 86 68) 100%)',
        background: '#FFBC0A',
        color: '#000',
    }),
}));

function ColorlibStepIcon(props: StepIconProps) {
    const { active, completed, className } = props;

    const icons: { [index: string]: React.ReactElement } = {
        1: <div>1</div>,
        2: <div>2</div>,
        3: <div>3</div>,
        4: <div>4</div>,
    };

    return (
        <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
            {icons[String(props.icon)]}
        </ColorlibStepIconRoot>
    );
}

const createIdo = () => {
    const { account, address, shard } = useGetAccountInfo();
    const { network } = useGetNetworkConfig();
    const { hasPendingTransactions } = useGetPendingTransactions();
    const networkProvider = new ProxyNetworkProvider(network.apiAddress);

    const steps = ['Verify Token', 'Add Launchpad Info', 'Add Additional Info', 'Finish and Review'];
    const [activeStep, setActiveStep] = useState<number>(0);
    const [idoCreated, setIdoCreated] = useState<boolean>(false);
    const [tokenInfo, setTokenInfo] = useState<any>();
    const [egldAmount, setEgldAmount] = useState<number>(0);
    const [wegldAmount, setWegldAmount] = useState<number>(0);
    const [presaleTokenAmount, setPresaleTokenAmount] = useState<number>(0);
    const [egldPrice, setEgldPrice] = useState<number>(0);
    const [errorMessage, setErrorMessage] = useState<string>('');

    useEffect(() => {
        (async () => {
            const amount = convertWeiToEsdt(account.balance, 18);
            setEgldAmount(amount.toNumber());
            const res0 = await axios.get(`${ElrondApiUrl}/accounts/${address}/tokens?identifier=${WEGLD_ID}`);
            if (res0.status == 200 && res0.data?.length > 0) {
                const token = res0.data[0];
                const tokenAmount = convertWeiToEsdt(token.balance, token.decimals);
                setWegldAmount(tokenAmount.toNumber());
            }
            const res1 = await axios.get(`${ElrondApiUrl}/mex/tokens?from=0&size=10000`);
            if (res1.status == 200 && res1.data?.length > 0) {
                const prices: any = res1.data;
                for (let i = 0; i < prices.length; i++) {
                    if (prices[i].id === WEGLD_ID) {
                        // console.log(prices[i].price);
                        setEgldPrice(prices[i].price);
                        break;
                    }
                }
            }
        })();
    }, [address]);

    const handleChangeStep = async (n: number) => {
        let stepN = n;
        if (stepN < 0) {
            stepN = 0;
        }
        if (stepN === 1) {
            // console.log(token_identifier);
            // console.log(currencyType);
            // check token id
            if (token_identifier && token_identifier.length > 0) {
                try {
                    const res: any = await axios.get(`${ElrondApiUrl}/tokens/${token_identifier}`);
                    if (res.status == 200) {
                        setTokenInfo(res.data);
                    } else {
                        stepN = 0;
                        toast.error('Token Identifier is incorrect');
                        return;
                    }
                    if (res.data.owner != address) {
                        stepN = 0;
                        toast.error('Token Identifier is incorrect');
                        return;
                    }
                    if (wegldAmount < LAUNCHPAD_CONFIG.pool_creation_fee && egldAmount < LAUNCHPAD_CONFIG.pool_creation_fee) {
                        stepN = 0;
                        toast.error('Insufficent funds');
                        return;
                    }
                    const res1 = await axios.get(`${ElrondApiUrl}/accounts/${address}/tokens?identifier=${token_identifier}`);
                    if (res1.status == 200 && res1.data?.length > 0) {
                        const token = res1.data[0];
                        const tokenAmount = convertWeiToEsdt(token.balance, token.decimals);
                        setPresaleTokenAmount(tokenAmount.toNumber());
                    }
                } catch (error) {
                    console.log(error);
                    stepN = 0;
                    toast.error('Token Identifier is incorrect');
                }

            } else {
                stepN = 0;
                toast.error('Token Identifier is incorrect');
            }
        }
        if (stepN === 2) {
            // console.log(presale_rate);
            if (presale_rate === undefined || presale_rate <= 0) {
                stepN = 1;
                toast.error('Presale rate is incorrect');
            }
            // console.log(hard_cap);
            if (hard_cap === undefined || hard_cap <= 0) {
                stepN = 1;
                toast.error('Hard Cap is incorrect');
            }
            // console.log(soft_cap);
            // if (soft_cap === undefined || hard_cap === undefined || soft_cap <= 0 || soft_cap < (hard_cap * LAUNCHPAD_CONFIG.min_percent_soft_cap / 100)) {
            //     stepN = 1;
            //     toast.error('Soft Cap is incorrect');
            // }
            // console.log(min_buy);
            if (min_buy === undefined || min_buy <= 0) {
                stepN = 1;
                toast.error('Minimum buy is incorrect');
            }
            // console.log(max_buy);
            if (max_buy === undefined || max_buy <= 0) {
                stepN = 1;
                toast.error('Maximum buy is incorrect');
            }
            // console.log(saleType);
            // console.log(moment(start_time).valueOf());
            if (Date.now() > moment(start_time).valueOf()) {
                stepN = 1;
                toast.error('Start Date is incorrect');
            }
            // console.log(end_time);
            if (Date.now() > moment(end_time).valueOf() || moment(end_time).valueOf() < moment(start_time).valueOf()) {
                stepN = 1;
                toast.error('End Date is incorrect');
            }
            const saleAmount = presale_rate * hard_cap;
            console.log(saleAmount, presaleTokenAmount, tokenInfo);
            if (saleAmount > presaleTokenAmount) {
                stepN = 1;
                toast.error('Insufficent fund');
            }
        }
        if (stepN === 3) {
            // console.log(description);
            if (description === undefined || description.length <= 0) {
                stepN = 2;
                toast.error('Please type description.');
            }
            const socials = [
                {
                    name: 'website',
                    link: inputWebsiteRef.current?.value
                },
                {
                    name: 'telegram',
                    link: inputTelegramRef.current?.value
                },
                {
                    name: 'discord',
                    link: inputDiscordRef.current?.value
                },
                {
                    name: 'twitter',
                    link: inputTwitterRef.current?.value
                },
                {
                    name: 'youtube',
                    link: inputYoutubeRef.current?.value
                },
                {
                    name: 'linkedIn',
                    link: inputLinkedInRef.current?.value
                },
                {
                    name: 'medium',
                    link: inputMediumRef.current?.value
                },
            ];
            setSocialLinks(socials);
        }
        if (stepN >= 4) {
            stepN = 3;
            // handle tx
            let fundTokenId = 'EGLD';
            let fundTokenDecimal = 18;
            if (currencyType == 'USDC') {
                fundTokenId = USDC_ID;
                fundTokenDecimal = 6;
            }
            const tokenCount: any = 2;
            const paymentTokenNonce: any = 0;
            // const paymentAmount = new BigNumber(LAUNCHPAD_CONFIG.pool_creation_fee).multipliedBy(Math.pow(10, 18));
            // const amount = new BigNumber(presale_rate * hard_cap).multipliedBy(Math.pow(10, tokenInfo.decimals));
            // const presaleRate = new BigNumber(presale_rate).multipliedBy(Math.pow(10, tokenInfo.decimals));
            // // const softCap = new BigNumber(soft_cap).multipliedBy(Math.pow(10, fundTokenDecimal));
            // const hardCap = new BigNumber(hard_cap).multipliedBy(Math.pow(10, fundTokenDecimal));
            // const minBuyAmount = new BigNumber(min_buy).multipliedBy(Math.pow(10, fundTokenDecimal));
            // const maxBuyAmount = new BigNumber(max_buy).multipliedBy(Math.pow(10, fundTokenDecimal));

            const paymentAmount = convertEsdtToWei(LAUNCHPAD_CONFIG.pool_creation_fee, 18);
            const amount = convertEsdtToWei(presale_rate * hard_cap, tokenInfo.decimals);
            const presaleRate = convertEsdtToWei(presale_rate, tokenInfo.decimals);
            // const softCap = convertEsdtToWei(soft_cap, fundTokenDecimal);
            const hardCap = convertEsdtToWei(hard_cap, fundTokenDecimal);
            const minBuyAmount = convertEsdtToWei(min_buy, fundTokenDecimal);
            const maxBuyAmount = convertEsdtToWei(max_buy, fundTokenDecimal);
            const start_unix_timestamp = moment(start_time).unix();
            const end_unix_timestamp = moment(end_time).unix();
            // console.log(start_time, start_unix_timestamp);
            // console.log(end_time, end_unix_timestamp);
            const args: TypedValue[] = [
                new AddressValue(new Address(contracts.Launchpad.address)),
                new U32Value(tokenCount),
                BytesValue.fromUTF8(WEGLD_ID),
                new U64Value(paymentTokenNonce),
                new BigUIntValue(paymentAmount.valueOf()),
                BytesValue.fromUTF8(tokenInfo.identifier),
                new U64Value(paymentTokenNonce),
                new BigUIntValue(amount.valueOf()),
                BytesValue.fromUTF8('create'),
                BytesValue.fromUTF8(tokenInfo.identifier),
                new U32Value(tokenInfo.decimals),
                BytesValue.fromUTF8(tokenInfo.name),
                BytesValue.fromUTF8(fundTokenId),
                new U32Value(fundTokenDecimal),
                new BigUIntValue(presaleRate.valueOf()),
                new BigUIntValue(hardCap.valueOf()),
                new BigUIntValue(minBuyAmount.valueOf()),
                new BigUIntValue(maxBuyAmount.valueOf()),
                new U64Value(start_unix_timestamp),
                new U64Value(end_unix_timestamp),
                BytesValue.fromUTF8(description),
                BytesValue.fromUTF8(socialLinks[0].link),
                BytesValue.fromUTF8(socialLinks[1].link),
                BytesValue.fromUTF8(socialLinks[2].link),
                BytesValue.fromUTF8(socialLinks[3].link),
                BytesValue.fromUTF8(socialLinks[4].link),
                BytesValue.fromUTF8(socialLinks[5].link),
                BytesValue.fromUTF8(socialLinks[6].link),
            ];
            const { argumentsString } = new ArgSerializer().valuesToString(args);
            const data = new TransactionPayload(`MultiESDTNFTTransfer@${argumentsString}`);

            let tx: any = [];
            if (wegldAmount >= LAUNCHPAD_CONFIG.pool_creation_fee) {
                tx = [
                    {
                        receiver: address,
                        gasLimit: 100000000,
                        value: 0,
                        data: data.toString(),
                    }
                ];
            } else {
                let wrapAddress = contracts.Wrap0.address;

                if (shard === 1) {
                    wrapAddress = contracts.Wrap1.address;
                } else if (shard === 2) {
                    wrapAddress = contracts.Wrap2.address;
                }

                tx = [
                    {
                        receiver: wrapAddress,
                        gasLimit: 6000000,
                        value: paymentAmount,
                        data: 'wrapEgld',
                    },
                    {
                        receiver: address,
                        gasLimit: 100000000,
                        value: 0,
                        data: data.toString(),
                    }
                ];
            }

            await refreshAccount();
            const result = await sendTransactions({
                transactions: tx,
            });

            console.log(result);
            setSessionId(result.sessionId);
        }
        setActiveStep(stepN);
    };

    const [sessionId, setSessionId] = useState<string>('');
    const transactionStatus = useTrackTransactionStatus({
        transactionId: sessionId,
    });

    useEffect(() => {
        if (transactionStatus.isSuccessful) {
            // console.log('success');
            setIdoCreated(true);
        }
    }, [sessionId, hasPendingTransactions]);

    /** step 1 */
    const [currencyType, setCurrencyType] = useState<string>('EGLD');
    const [feeType, setFeeType] = useState<string>('fee_type_0');
    const [saleType, setSaleType] = useState<string>('sale_type_0');

    const handleCurrencyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCurrencyType((event.target as HTMLInputElement).value);
    };

    const handleFeeTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFeeType((event.target as HTMLInputElement).value);
    };
    const handleSaleTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSaleType((event.target as HTMLInputElement).value);
    };


    /** step 2 */

    /*
    const [isWhitelisted, setWhitelist] = useState<boolean>(true);
    const handleWhitelistChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        console.log(event.target.value);
        setWhitelist(event.target.value === 'true');
    };
    */
    const [token_identifier, setTokenIdentifier] = useState<string | undefined>('');

    const [presale_rate, setPreSaleRate] = useState<any>();
    const [soft_cap, setSoftCap] = useState<any>(0);
    const [hard_cap, setHardCap] = useState<any>(0);
    const [min_buy, setMinimumBuy] = useState<any>(0);
    const [max_buy, setMaximumBuy] = useState<any>(0);
    const [maiar_exchange_liquidity, setMaiarExchangeLiquidity] = useState<number | undefined>();
    const [maiar_listing_rate, setMaiarListingRate] = useState<number | undefined>();
    const [start_time, setStartTime] = useState<Date | null>(new Date());
    const [end_time, setEndTime] = useState<Date | null>(new Date());
    const [liquidity_lockup_days, setLiquidityLockupDays] = useState<number | undefined>();

    const [description, setDescription] = useState<string>('');
    const [socialLinks, setSocialLinks] = useState<any>([]);

    const inputWebsiteRef = useRef<HTMLInputElement>(null);
    const inputTelegramRef = useRef<HTMLInputElement>(null);
    const inputDiscordRef = useRef<HTMLInputElement>(null);
    const inputTwitterRef = useRef<HTMLInputElement>(null);
    const inputYoutubeRef = useRef<HTMLInputElement>(null);
    const inputLinkedInRef = useRef<HTMLInputElement>(null);
    const inputMediumRef = useRef<HTMLInputElement>(null);

    return (
        <div className='launchpad-create-container flex-fill'>

            {
                idoCreated && (
                    <>
                        <div className='ido-launched-box d-flex justify-content-center align-items-center flex-column'>
                            <img className='congratulations-img' src={congratulations_img} alt='IDO created successfully' />
                            <div className='mt-3'>
                                <Link to={routeNames.launchpad}>
                                    <span style={{ color: 'white', textDecoration: 'underline' }}>Go Home</span>
                                </Link>
                            </div>
                        </div>
                    </>
                )
            }
            {
                !idoCreated && (
                    <div className='home-container mb-5'>
                        <div className='d-flex flex-column justify-content-center align-items-center mb-5'>
                            <span className='launchpad-title'>{'OneDex Permissionless Launchpad'}</span>

                            <div className='launchpad-description mt-4'>
                                <span>{'First decentralized IDO platform for MultiversX. Launchpad will empower crypto currency projects with the ability to distribute tokens and raise liquidity.'}</span>
                            </div>
                        </div>

                        <Box sx={{ width: '100%', marginTop: '40px' }}>
                            <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                                {steps.map((label) => (
                                    <Step key={label}>
                                        <StepLabel StepIconComponent={ColorlibStepIcon}><span style={{ color: '#D3D3D3', fontSize: '13px' }}>{label}</span></StepLabel>
                                    </Step>
                                ))}
                            </Stepper>

                            {/** step 1 */}
                            <div className='Step-Box mt-5'>
                                {
                                    activeStep == 0 && (
                                        <>
                                            <p className='step-title mt-3 mb-0'>Token Identifier *</p>
                                            <input
                                                className='ido-input'
                                                value={token_identifier}
                                                onChange={(e) => setTokenIdentifier(e.target.value)}
                                            />
                                            <span className='input-comment warning'>Pool creation fee: {LAUNCHPAD_CONFIG.pool_creation_fee} EGLD + {LAUNCHPAD_CONFIG.fee_percent_fund_token}% of raised amount</span>

                                            <p className='step-title mt-3 mb-0'>Currency </p>
                                            <FormControl>
                                                {/* <FormLabel id='demo-controlled-radio-buttons-group'>Gender</FormLabel> */}
                                                <RadioGroup
                                                    row
                                                    aria-labelledby='demo-controlled-radio-buttons-group'
                                                    name='controlled-radio-buttons-group'
                                                    value={currencyType}
                                                    onChange={handleCurrencyChange}
                                                >
                                                    <FormControlLabel
                                                        value='EGLD'
                                                        control={<Radio sx={{
                                                            color: '#6A9B84 !important',
                                                            '&.Mui-checked': {
                                                                color: '#6A9B84 !important',
                                                            },
                                                        }} />}
                                                        label='EGLD' />
                                                    <FormControlLabel
                                                        value='USDC'
                                                        control={<Radio sx={{
                                                            color: '#6A9B84 !important',
                                                            '&.Mui-checked': {
                                                                color: '#6A9B84 !important',
                                                            },
                                                        }} />}
                                                        label='USDC' />
                                                </RadioGroup>
                                            </FormControl>
                                        </>
                                    )
                                }

                                {
                                    activeStep == 1 && (
                                        <>
                                            <div className='mt-3'>
                                                <div className='input-state'>Presale Rate *</div>
                                                <input
                                                    className='ido-input mt-2 mb-1'
                                                    type='number'
                                                    value={presale_rate}
                                                    onChange={(e) => setPreSaleRate(e.target.value)}
                                                />
                                                <span className='input-comment warning'>If I spend 1 {currencyType} how many tokens will I receive?</span>
                                            </div>

                                            <div>
                                                <Row className='mt-4 mb-4'>
                                                    {/* <Col sm={6}>
                                                        <div className='input-state '>SoftCap ({currencyType}) *</div>
                                                        <input
                                                            className='ido-input mt-2 mb-1'
                                                            type='number'
                                                            value={soft_cap}
                                                            onChange={(e) => setSoftCap(e.target.value)}
                                                        />
                                                        <span className='input-comment'>{'SoftCap must be >= ' + LAUNCHPAD_CONFIG.min_percent_soft_cap + '% of HardCap'}</span>
                                                    </Col> */}
                                                    <Col sm={6}>
                                                        <div className='input-state '>HardCap ({currencyType}) *</div>
                                                        <input
                                                            className='ido-input mt-2 mb-1'
                                                            type='number'
                                                            value={hard_cap}
                                                            onChange={(e) => setHardCap(e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col sm={6}></Col>
                                                    <Col sm={6}>
                                                        <div className='input-state '>Minimum Buy ({currencyType}) *</div>
                                                        <input
                                                            className='ido-input mt-2 mb-1'
                                                            type='number'
                                                            value={min_buy}
                                                            onChange={(e) => setMinimumBuy(e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col sm={6}>
                                                        <div className='input-state '>Maximum Buy ({currencyType}) *</div>
                                                        <input
                                                            className='ido-input mt-2 mb-1'
                                                            type='number'
                                                            value={max_buy}
                                                            onChange={(e) => setMaximumBuy(e.target.value)}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className='mt-4 mb-4'>
                                                    <Col sm={6}>
                                                        <div className='input-state '>Start time (UTC) *</div>
                                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                            <MobileDateTimePicker
                                                                value={start_time}
                                                                onChange={(newValue) => {
                                                                    setStartTime(newValue);
                                                                }}
                                                                renderInput={(params) => <TextField {...params} />}
                                                                minDateTime={new Date()}
                                                            />
                                                        </LocalizationProvider>
                                                    </Col>
                                                    <Col sm={6}>
                                                        <div className='input-state '>End time (UTC) *</div>
                                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                            <MobileDateTimePicker
                                                                value={end_time}
                                                                onChange={(newValue) => {
                                                                    setEndTime(newValue);
                                                                }}
                                                                renderInput={(params) => <TextField {...params} />}
                                                                minDateTime={new Date()}
                                                            />
                                                        </LocalizationProvider>
                                                    </Col>
                                                </Row>

                                                {/* <div className='d-flex justify-content-center mt-5'>
													<h5 style={{ color: '#2996B8' }}>
														Not enough balance in your wallet. Need 350000 CTP to create launchpad. (Your balance: XXX CTP)
													</h5>
												</div> */}
                                            </div>
                                        </>
                                    )
                                }

                                {
                                    activeStep == 2 && (
                                        <>
                                            <p className='step-title mt-3'>Let People know who you are *</p>

                                            <Row>
                                                <Col sm={12}>
                                                    <div className='input-state '>Description *</div>
                                                    <textarea
                                                        className='ido-input'
                                                        value={description}
                                                        onChange={(e) => setDescription(e.target.value)}
                                                        style={{ minHeight: '100px' }}
                                                    />
                                                </Col>
                                                {/* <Col sm={6}>
													<div className='input-state '>Token For Presale *</div>
													<input className='ido-input' />
												</Col>
												<Col sm={6}>
													<div className='input-state '>Token For Liquidity *</div>
													<input className='ido-input' />
												</Col> */}
                                            </Row>

                                            <p className='step-title mt-5'>Social Links</p>
                                            <div className='d-flex flex-column' style={{ rowGap: '10px' }}>
                                                <div className='d-flex align-items-center justify-content-center'>
                                                    <div style={{ fontSize: '20px', color: 'white' }}> <ImEarth /> </div>
                                                    <input className='ido-input ml-2' ref={inputWebsiteRef} />
                                                </div>

                                                <div className='d-flex'>
                                                    <div style={{ fontSize: '20px', color: 'white' }}> <SiTelegram /> </div>
                                                    <input className='ido-input ml-2' ref={inputTelegramRef} />
                                                </div>

                                                <div className='d-flex'>
                                                    <div style={{ fontSize: '20px', color: 'white' }}> <SiDiscord /> </div>
                                                    <input className='ido-input ml-2' ref={inputDiscordRef} />
                                                </div>

                                                <div className='d-flex'>
                                                    <div style={{ fontSize: '20px', color: 'white' }}> <SiTwitter /> </div>
                                                    <input className='ido-input ml-2' ref={inputTwitterRef} />
                                                </div>

                                                <div className='d-flex'>
                                                    <div style={{ fontSize: '20px', color: 'white' }}> <SiYoutube /> </div>
                                                    <input className='ido-input ml-2' ref={inputYoutubeRef} />
                                                </div>

                                                <div className='d-flex'>
                                                    <div style={{ fontSize: '20px', color: 'white' }}> <SiLinkedin /> </div>
                                                    <input className='ido-input ml-2' ref={inputLinkedInRef} />
                                                </div>

                                                <div className='d-flex'>
                                                    <div style={{ fontSize: '20px', color: 'white' }}> <SiMedium /> </div>
                                                    <input className='ido-input ml-2' ref={inputMediumRef} />
                                                </div>
                                            </div>
                                        </>
                                    )
                                }

                                {
                                    activeStep == 3 && (
                                        <>
                                            <div className='d-flex align-items-center'>
                                                <div className='d-flex flex-column'>
                                                    <span className='IDO-Card-title' style={{ fontSize: '20px' }}>{tokenInfo?.name}</span>
                                                </div>
                                            </div>

                                            <div className='mt-3'>
                                                <div style={{ fontSize: '16px', color: 'white' }}>{description}</div>
                                                {/* <div className='mt-2' style={{ fontSize: '16px', color: '#E3E3E3' }}>{'Your investment is protected, this sale is under the Safeguarded Launch Protocol rules.'}</div> */}
                                            </div>

                                            <div className='social-box mt-4'>
                                                {
                                                    socialLinks[0].link !== '' && (
                                                        <a className='social-link' href={socialLinks[0].link} rel='noreferrer' target='_blank'>
                                                            <ImEarth />
                                                        </a>
                                                    )
                                                }
                                                {
                                                    socialLinks[1].link !== '' && (
                                                        <a className='social-link' href={socialLinks[1].link} rel='noreferrer' target='_blank'>
                                                            <SiTelegram />
                                                        </a>
                                                    )
                                                }
                                                {
                                                    socialLinks[2].link !== '' && (
                                                        <a className='social-link' href={socialLinks[2].link} rel='noreferrer' target='_blank'>
                                                            <SiDiscord />
                                                        </a>
                                                    )
                                                }
                                                {
                                                    socialLinks[3].link !== '' && (
                                                        <a className='social-link' href={socialLinks[3].link} rel='noreferrer' target='_blank'>
                                                            <SiTwitter />
                                                        </a>
                                                    )
                                                }
                                                {
                                                    socialLinks[4].link !== '' && (
                                                        <a className='social-link' href={socialLinks[4].link} rel='noreferrer' target='_blank'>
                                                            <SiYoutube />
                                                        </a>
                                                    )
                                                }
                                                {
                                                    socialLinks[5].link !== '' && (
                                                        <a className='social-link' href={socialLinks[5].link} rel='noreferrer' target='_blank'>
                                                            <SiLinkedin />
                                                        </a>
                                                    )
                                                }
                                                {
                                                    socialLinks[6].link !== '' && (
                                                        <a className='social-link' href={socialLinks[6].link} rel='noreferrer' target='_blank'>
                                                            <SiMedium />
                                                        </a>
                                                    )
                                                }
                                            </div>

                                            <div className='mt-4'>
                                                <div className='d-flex flex-column' style={{ rowGap: '6px' }}>
                                                    <p style={{ fontSize: '22px', color: 'white', fontWeight: '700' }}>TOKEN</p>
                                                    <div>
                                                        <span>Token: </span>
                                                        <span style={{ color: '#6a9b84' }}>{tokenInfo?.name}</span>
                                                    </div>
                                                    <div>
                                                        <span>Token Identifier: </span>
                                                        <span style={{ color: '#6a9b84' }}>{tokenInfo?.identifier}</span>
                                                    </div>
                                                    <div>
                                                        <span>Token Decimal: </span>
                                                        <span style={{ color: '#6a9b84' }}>{tokenInfo?.decimals}</span>
                                                    </div>
                                                    <div>
                                                        <span>Total Supply: </span>
                                                        <span style={{ color: '#6a9b84' }}>{tokenInfo?.supply?.toLocaleString()} {tokenInfo?.name}</span>
                                                    </div>
                                                </div>

                                                <div className='d-flex flex-column mt-4' style={{ rowGap: '6px' }}>
                                                    <p style={{ fontSize: '20px', color: 'white', fontWeight: '700' }}>PRICE</p>
                                                    <div>
                                                        <span>1 {tokenInfo?.name} : </span>
                                                        <span style={{ color: '#6a9b84' }}>${currencyType != 'EGLD' ? (1 / presale_rate).toFixed(5) : (egldPrice / presale_rate).toFixed(5)}</span>
                                                    </div>
                                                </div>

                                                <div className='d-flex flex-column mt-4' style={{ rowGap: '6px' }}>
                                                    <p style={{ fontSize: '20px', color: 'white', fontWeight: '700' }}>POOL DETAILS</p>
                                                    {/* <div>
                                                        <span>SoftCap: </span>
                                                        <span style={{ color: '#6a9b84' }}>{soft_cap} {currencyType}</span>
                                                    </div> */}
                                                    <div>
                                                        <span>HardCap: </span>
                                                        <span style={{ color: '#6a9b84' }}>{hard_cap} {currencyType}</span>
                                                    </div>
                                                    <div>
                                                        <span>Minimum Buy: </span>
                                                        <span style={{ color: '#6a9b84' }}>{min_buy} {currencyType}</span>
                                                    </div>
                                                    <div>
                                                        <span>Maximum Buy: </span>
                                                        <span style={{ color: '#6a9b84' }}>{max_buy} {currencyType}</span>
                                                    </div>
                                                    <div>
                                                        <span>Sale Type: </span>
                                                        <span style={{ color: '#6a9b84' }}>PUBLIC</span>
                                                        {/* <span style={{ color: '#6a9b84' }}>{saleType === 'sale_type_0' ? 'Public' : (saleType === 'sale_type_1' ? 'Private' : 'Whitelist')}</span> */}
                                                    </div>
                                                    <div>
                                                        <span>Starts / end: </span>
                                                        <span style={{ color: '#6a9b84' }}>{moment(start_time).format('DD MMM YYYY hh:mm a')} - {moment(end_time).format('DD MMM YYYY hh:mm a')}</span>
                                                    </div>
                                                    {/* <div>
														<span>Registration: </span>
														<span style={{ color: '#6a9b84' }}>{Date.now()}</span>
													</div> */}
                                                </div>

                                                {/* <div className='d-flex flex-column mt-5' style={{ rowGap: '6px' }}>
													<p style={{ fontSize: '20px', color: '#6a9b84', fontWeight: '700' }}>DISTRIBUTION</p>
													<div>
														<span>Distribution: </span>
														<span style={{ color: '#6a9b84' }}>Claimed on IDO Launchpad</span>
													</div>
													<div>
														<span>Vesting: </span>
														<span style={{ color: '#6a9b84' }}>Loerem Ipsum dollar</span>
													</div>
												</div> */}
                                            </div>
                                        </>
                                    )
                                }

                                <div className='d-flex justify-content-center mb-5 mt-4'>
                                    <button className='ido-create-back-but' onClick={() => handleChangeStep(activeStep - 1)}>Back</button>
                                    <button className='ido-create-next-but ml-3' onClick={() => handleChangeStep(activeStep + 1)}>{activeStep == 3 ? 'Submit' : 'Next'}</button>
                                </div>
                            </div>
                        </Box>
                    </div >
                )
            }
        </div>
    );
};

export default createIdo;